const BASEURL = process.env.VUE_APP_API_HOST
const BASE_API_URL = `${BASEURL}`

const BEELIVE_URL = process.env.VUE_APP_BEELIVE_HOST
const BEELIVE_API_URL = `${BEELIVE_URL}`

const BEELIVE_SESSION_URL = process.env.VUE_APP_BEELIVE_SESSION_URL
const BEELIVE_SESSION_API_URL = `${BEELIVE_SESSION_URL}`

const BIOMETRY_API_KEY
  = process.env.NODE_ENV === 'development'
    ? `Dlg3dWO4gMXzZUSpXrl-2DZ8Mjh90ceXBzstbq0Va0o`
    : `C3plOcTi6lQ5fKWQoybtS43kqYxd6IuhKaJZXG0KFmA`

const BEEDOC_URL = process.env.VUE_APP_BEEDOC_HOST
const BEEDOC_API_URL = `${BEEDOC_URL}`

export {
  BASE_API_URL,
  BEELIVE_API_URL,
  BEEDOC_API_URL,
  BIOMETRY_API_KEY,
  BEELIVE_SESSION_API_URL,
}
